module.exports = "/images/modal-goals.svg?abb61bd5e93426abf60a43a774044c62";